export default __webpack_public_path__ + "static/media/Logo.a5aba7f2.svg";